module.exports = __webpack_public_path__ + "media/thumbnails/glove-style-1-76f7b3cd.svg";